import React, { useState, useEffect } from "react";
import styles from "./Customers.module.sass";
import Overview from "./Overview";
import Dashboard from "./Dashboard"; // This component has been updated
import TopFormation from "./TopFormation";
import ContractType from "./ContractType";
import StatRupture from "./StatRupture";
import RefundRequests from "./RefundRequests";
import { getActiveBanners } from "../../services/banner.service";

const Home = () => {
  const [banners, setBanners] = useState([]);
  const [bannersLoading, setBannersLoading] = useState(true);

  useEffect(() => {
    const fetchActiveBanners = async () => {
      try {
        const activeBanners = await getActiveBanners();
        setBanners(activeBanners);
      } catch (error) {
        console.error('Erreur lors du chargement des banners:', error);
      } finally {
        setBannersLoading(false);
      }
    };

    fetchActiveBanners();
  }, []);

  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
    
          <div className={styles.row}>
            <div className={styles.col}>
              <Dashboard className={styles.card} />
              <Overview className={styles.card} />
              <StatRupture className={styles.card} />
            </div>
            <div className={styles.col}>
              {(!bannersLoading && banners.length > 0) && (
                <RefundRequests 
                  className={styles.card} 
                  banners={banners}
                  title={banners[0]?.type || "Notifications"}
                  loading={bannersLoading}
                />
              )}
              <TopFormation className={styles.card} />
              <ContractType className={styles.card} />
            </div>
          </div>
        </div>

    </>
  );
};

export default Home;
